module.exports = __webpack_public_path__ + "img/f58.555ee257.png";